import { render, staticRenderFns } from "./BreadcrumbSession.vue?vue&type=template&id=f6563804&"
import script from "./BreadcrumbSession.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports